import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { FormControl } from '@angular/forms';
import { Location } from "../../services/locations.service";
import { FareLocation } from 'app/services';

@Component({
  selector: 'location-select',
  templateUrl: 'location-select.html'
})
export class LocationSelectComponent {
  @Input() label:string;
  @Input() locationList: FareLocation[];
  @Input() other:string;
  @Input() set otherRefresh(key:string) {
    if(!key && key.length > 0 ){
      this.handleSelectLocation(this.selectedLocation);
    }
  }  

  @Input() set select(select:FareLocation) {
    if(!select || !select.locationId ){
      this.clearLocations(true);
    }else{
      this.handleSelectLocation(select, true);
    }
  }  
  @Input() focusOpen:boolean = false;
     

  @Output() onSelect: EventEmitter<FareLocation> = new EventEmitter();

  showDropDown: boolean = false;
  showAutoList: boolean = false;

  suggestList: Array<any> = [];

  locationControl: FormControl = new FormControl();

  focusedIndex: number = 0;
  selectedLocation: FareLocation = new FareLocation();

  @ViewChild("suggestListRef")
  suggestListElRef: ElementRef;

  clickOutside() {
    if (this.showDropDown || (this.suggestList && this.suggestList.length > 0)) {
      this.clearLocations();
    } else {
      this.showDropDown =  false;
      this.showAutoList = false;
    }
  }

  open(){
    if(this.focusOpen) {
      this.suggestList = this.locationList;
    }
  }

  close(){
    if(this.focusOpen) this.suggestList = [];
  }
  

  clearLocations(isNotEmit?:boolean) {
    this.selectedLocation = new FareLocation();
    this.showDropDown =  false;
    this.suggestList = [];
    this.focusedIndex = 0;
    if(!isNotEmit) this.onSelect.emit(null);
    this.locationControl.setValue(null);
  }

  handleSuggest(e) {
    let locationList = this.locationList;

    let value = e.target.value;
    const inputValue = _.toUpper(value.trim()).replace(/\s/g, '');
    const inputLength = inputValue.length;

    let filteredList = [];
    let codeList = [];
    
    if (inputValue.length > 0) {
      codeList = _.filter(
        locationList,
        (location) => {
          return location.cntryCd === inputValue;
        }
      );

      filteredList = _.filter(locationList,
                                (location) => {
                                  let locationLabel = _.toUpper(location.name).replace(/\s/g, '');
                                  return location.cntryCd != inputValue && locationLabel.indexOf(inputValue) >= 0;
                                }
                              );
      
      filteredList = _.sortBy(
        filteredList,
        (location) => {
          let lineLabel = _.toUpper(location.name).replace(/:/g, 'AAAAAAAAAAA');
          return lineLabel;
        }
      );
      filteredList = _.sortBy(
        filteredList,
        (location) => {
          let lineLabel = _.toUpper(location.name).replace(/\s/g, '');
          return _.toUpper(lineLabel).indexOf(inputValue);
        }
      );

      filteredList = codeList.concat(filteredList);
    }

    
    this.showDropDown = false;
    this.showAutoList = false;
    

    if(this.focusOpen && value.length < 1){
      this.suggestList = this.locationList;
    }else{
      this.suggestList = filteredList;
    }
    
    this.selectedLocation = new FareLocation();
    this.focusedIndex = 0;
    
  }

  handleKeyDown(event) {
    if (event.keyCode !== 9 && event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40) return;
    
    let focusedIndex = this.focusedIndex;
    let suggestListDom = null;
    if(this.suggestListElRef) suggestListDom = this.suggestListElRef.nativeElement;
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');

    let line = this.suggestList[this.focusedIndex];

		switch (event.keyCode) {
      case 9: //tab
        if (line) this.handleSelectLocation(line);
        break;
			case 13: // enter
        if (line) this.handleSelectLocation(line);
			  break;
			case 27: // escape
				this.clearLocations();
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > this.suggestList.length - 1) focusedIndex = this.suggestList.length - 1;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }
    if(event.keyCode != 9) {
      event.preventDefault();
    }
  }

  handleShowDropDown() {
    this.showDropDown = !this.showDropDown;
  }

  handleSelectLocation(location, isNotEmit?:boolean) {
    this.selectedLocation = location;
    let lineName = this.selectedLocation.name + ' / ' + this.selectedLocation.cntryCd;
    if(this.other){
      lineName += this.selectedLocation[this.other];
    }
    this.locationControl.setValue(lineName);

    if(!isNotEmit) this.onSelect.emit(this.selectedLocation);

    this.showDropDown = false;
    this.suggestList = [];
  }
}


// WEBPACK FOOTER //
// ./src/app/components/selector/location-select.ts